/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  BasicInfoEditModeType,
  BasicInfoLoadingType,
} from "~/components/BasicCustomerInfo/types";

export const BasicInfoEditModeInitialState: BasicInfoEditModeType = {
  links: false,
  addressDetails: false,
  location: false,
  languages: false,
  categories: false,
  businessId: false,
  salesforceId: false,
  providers: false,
  currency: false,
  businessHours: false,
  value: false,
  premiumSupportCSP: null,
  onboardingDate: false,
  offboardingDate: false,
  ibmCustomer: false,
  segment: false,
  serviceRequestEmail: false,
  raiseAlarmEmail: false,
};

export const BasicInfoLoadingInitialState: BasicInfoLoadingType = {
  links: false,
  addressDetails: false,
  location: false,
  languages: false,
  categories: false,
  businessId: false,
  salesforceId: false,
  providers: false,
  currency: false,
  businessHours: false,
  value: false,
  premiumSupportCSP: null,
  onboardingDate: false,
  offboardingDate: false,
  ibmCustomer: false,
  segment: false,
  serviceRequestEmail: false,
  raiseAlarmEmail: false,
};
